import { CommitmentsCommandsService_commitmentCommandsServiceGetEntities } from '@festina/life-general-types/life/hooks/CommitmentsCommandsService_commitmentCommandsServiceGetEntities'

export const useFetchCommitmentCommands =
  CommitmentsCommandsService_commitmentCommandsServiceGetEntities.useSuspenseQuery
